export const EMOJI_PANEL_REACTION_LIST = [
  { id: 'clap', emoji: '👏' },
  { id: 'thumbs_up', emoji: '👍' },
  { id: 'heart', emoji: '❤️' },
  { id: 'laugh', emoji: '😂' },
  { id: 'celebrate', emoji: '🎉' },
  { id: 'idea', emoji: '💡' }
] as const;

export const EMOJI_LOOKUP_MAP = new Map<string, { emoji: string }>(
  EMOJI_PANEL_REACTION_LIST.map(e => [e.id, { emoji: e.emoji }])
);
export type FloatingEmojiReaction = (typeof EMOJI_PANEL_REACTION_LIST)[number];

export enum ParticleMode {
  Float = 'float',
  Cannon = 'cannon'
}

export type FloatingEmojiParticle =
  | { emoji: string; mode: ParticleMode.Float }
  | { emoji: string; mode: ParticleMode.Cannon; count?: number };

export type ReactionListener = (particles: FloatingEmojiParticle[]) => void;

export type DeviceTier = 'mobile' | 'tablet' | 'desktop';

export type Particle = {
  emoji: string;
  spawnX: number;
  spawnY: number;
  targetY: number;
  fadeStartY: number;
  fadeEndY: number;
  size: number;
  lifetime: number;
  driftAmplitude: number;
  driftDir: 1 | -1;
  driftPhase: number;
  age: number;
};

export type RenderState = { x: number; y: number; opacity: number; scale: number; rotation: number };
